var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21,
  _t22,
  _t23,
  _t24,
  _t25,
  _t26,
  _t27,
  _t28,
  _t29,
  _t30,
  _t31,
  _t32,
  _t33,
  _t34,
  _t35,
  _t36,
  _t37,
  _t38,
  _t39,
  _t40,
  _t41,
  _t42,
  _t43,
  _t44,
  _t45,
  _t46,
  _t47,
  _t48,
  _t49;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import * as dayjs from 'dayjs';
import { html, LitElement } from 'lit';
import groupBy from "lodash/groupBy";
import css from './style.pcss';
import translations from '../../common/sport/translations';
import HighlightButtonImage from "../../common/images/btn_highlights.svg";
import LiveButtonImage from "../../common/images/btn_live.svg";
import LiveArenaButtonImage from "../../common/images/btn_livearena.svg";
import LivetickerButtonImage from "../../common/images/btn_liveticker.svg";
import PauseButtonImage from "../../common/images/btn_pause.svg";
import ReplayButtonImage from "../../common/images/btn_replay.svg";
import TickerButtonImage from "../../common/images/btn_ticker.svg";
import ArrowDownImage from "../../common/images/arrow-down-white.svg";
import ApartLogo from "../../common/images/aparttv_btn.svg";
import PlaceholderLogo from "../../common/images/logo_placeholder.svg";
import { helper } from "../../common/helper";

//import { groupBy } from 'lodash';
var RTLSportResults = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportResults, _LitElement);
  function RTLSportResults() {
    var _this;
    _classCallCheck(this, RTLSportResults);
    _this = _callSuper(this, RTLSportResults);
    _this.view = 'default';
    _this.language = 'lu';
    _this.matchid = null;
    _this.showLogos = true;
    _this.type = 'large';
    _this.competition = 0;
    _this.competitionName = "";
    _this.aparttvMatches = [];
    _this.interval = setInterval(_this._fetchData.bind(_assertThisInitialized(_this)), 15000);
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
      _this.version = window.rtlsites.config.version;
    }
    _this.apiUrl = "https://api-gate.rtl.lu/sport";
    return _this;
  }
  _createClass(RTLSportResults, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportResults.prototype), "connectedCallback", this).call(this);
      this._fetchCompetitions();
    }
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      if (this.competition === 109 || this.competition === 119) {
        this.showLogos = true;
      }
    }
  }, {
    key: "_fetchData",
    value: function () {
      var _fetchData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var dataAPI, matchDates, resp, _resp;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Results
              matchDates = [];
              if (this.round) {
                dataAPI = `${this.apiUrl}/sports/${this.sport}/competitions/${this.competition}/results/${this.round}?lang=${this.language}`;
              } else {
                dataAPI = `${this.apiUrl}/sports/${this.sport}/competitions/${this.competition}/results/current?lang=${this.language}`;
              }
              _context.prev = 2;
              _context.next = 5;
              return fetch(dataAPI).then(function (resp) {
                return resp.json();
              });
            case 5:
              resp = _context.sent;
              this.data = resp;
              this.filteredResults = groupBy(this.data.results.matches, function (match) {
                matchDates.push(match.date);
                if (match.hour) return dayjs(match.date + " " + match.hour).format('DD/MM/YYYY HH:mm');else {
                  if (match.date && match.info !== 'date_unknown') return dayjs(match.date).format('DD/MM/YYYY');
                  if (match.info === 'postponed') return _this2._getTranslation('postponed');
                  if (match.info === 'date_unknown') return _this2._getTranslation('date_unknown');
                }
              });
              this.round = this.data.results.round_id;
              this.view = 'default';
              this.link = this._getLink();
              this.livearena_sports = [1, 2, 3, 4];
              _context.next = 18;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](2);
              if (this.interval) clearInterval(this.interval);
              console.log('ERROR: ' + error.message);
            case 18:
              if (!(this.sport === 3)) {
                _context.next = 24;
                break;
              }
              //wann handball mussen ma och apart-tv fetchen
              matchDates = _toConsumableArray(new Set(matchDates)); // make unique
              _context.next = 22;
              return fetch("https://api-gate.rtl.lu/sport/apart-tv?dates=" + matchDates.join(",")).then(function (resp) {
                return resp.json();
              });
            case 22:
              _resp = _context.sent;
              this.aparttvMatches = _resp;
              // console.log("this.aparttvMatches", this.aparttvMatches)
              // console.log("allMatches", this.data.results)
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 14]]);
      }));
      function _fetchData() {
        return _fetchData2.apply(this, arguments);
      }
      return _fetchData;
    }()
  }, {
    key: "_fetchCompetitions",
    value: function _fetchCompetitions() {
      var _this3 = this;
      // Competitions
      var compAPI = `${this.apiUrl}/sports/${this.sport}/competitions?lang=${this.language}`;
      fetch(compAPI).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this3.competitions = resp;
        var currentComp;
        if (_this3.competition === 0) {
          currentComp = _this3.competitions.filter(function (comp) {
            if (comp.priority === true) {
              return true;
            }
            return false;
          });
        } else {
          currentComp = _this3.competitions.filter(function (comp) {
            if (comp.id === _this3.competition) {
              return true;
            }
            return false;
          });
        }
        if (currentComp.length >= 1) {
          _this3.competition = currentComp[0].id;
          _this3.competitionName = currentComp[0].name;
        }
        _this3._fetchData();
      });
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_getLink",
    value: function _getLink() {
      var link;
      if (this.language === 'fr') link = `/sport/resultats`;
      if (this.language === 'lu') link = `/sport/${this._getTranslation('sport' + this.sport)}/resultater`;
      return link;
    }
  }, {
    key: "_showRound",
    value: function _showRound(e) {
      if (e.target.value) {
        if (this.type === 'main') {
          document.location.href = `${this.link}/national?c=${this.competition}&r=${e.target.value}`;
          return;
        }
        this.round = e.target.value;
        this._fetchData();
      }
    }
  }, {
    key: "_showCompetition",
    value: function _showCompetition(e) {
      if (e.target.value) {
        if (this.type === 'main') {
          document.location.href = `${this.link}/national?c=${e.target.value}`;
          return;
        }
        this.competition = e.target.value;
        this.round = null;
        this._fetchData();
      }
    }

    // TODO: Params cleanup
  }, {
    key: "_showLiveticker",
    value: function _showLiveticker(e, match, has_details, live_arena_id, live_arena_hidden) {
      var summary = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      if (!has_details && !live_arena_id) return;
      helper.openLivearenaLink(match.id, summary, this.sport, match.has_ticker);

      //this.view = 'liveticker';
      //this.matchid = matchid;
    }
  }, {
    key: "_showResultsAndTable",
    value: function _showResultsAndTable(e) {
      if (this.type === 'article') {
        window.open(`${this.link}/national?c=${this.competition}`, '_blank');
        return;
      }
      document.location.href = `${this.link}/national?c=${this.competition}`;
    }
  }, {
    key: "_renderLiveticker",
    value: function _renderLiveticker() {
      var _this4 = this;
      return html(_t || (_t = _`
            <div style="cursor: pointer; text-align: left" @click=${0}>&laquo; ${0}</div>
            <rtl-sport-liveticker sport="${0}" competition="${0}" match="${0}"></rtl-sport-liveticker>
        `), function (e) {
        return _this4._fetchData();
      }, this._getTranslation('back'), this.sport, this.competition, this.matchid);
    }
  }, {
    key: "_renderLegendBySport",
    value: function _renderLegendBySport() {
      switch (this.sport) {
        case 1:
          return html(_t2 || (_t2 = _`
                <div class="legend">
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    ${0}
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                </div>
                `), this._getTranslation('aborted-1_short'), this._getTranslation('aborted-1'), this._getTranslation('postponed-1_short'), this._getTranslation('postponed-1'), this.data.competition.cup ? html(_t3 || (_t3 = _`
                        <dl class="legend-list">
                            <dt class="legend-terme">${0}</dt>
                            <dd class="legend-definiton">${0}</dd>
                        </dl>
                        <dl class="legend-list">
                            <dt class="legend-terme">${0}</dt>
                            <dd class="legend-definiton">${0}</dd>
                        </dl>
                    `), this._getTranslation('penalty-1_short'), this._getTranslation('penalty-1'), this._getTranslation('overtime-1_short'), this._getTranslation('overtime-1')) : '', this._getTranslation('forfait-1_short'), this._getTranslation('forfait-1'));
        case 2:
          return html(_t4 || (_t4 = _`
                <div class="legend">
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                </div>
                `), this._getTranslation('aborted-2_short'), this._getTranslation('aborted-2'), this._getTranslation('postponed-2_short'), this._getTranslation('postponed-2'), this._getTranslation('overtime-2_short'), this._getTranslation('overtime-2'), this._getTranslation('forfait-2_short'), this._getTranslation('forfait-2'));
        case 3:
          return html(_t5 || (_t5 = _`
                <div class="legend">
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    ${0}
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                </div>
                `), this._getTranslation('aborted-3_short'), this._getTranslation('aborted-3'), this._getTranslation('postponed-3_short'), this._getTranslation('postponed-3'), this.data.competition.cup ? html(_t6 || (_t6 = _`
                        <dl class="legend-list">
                            <dt class="legend-terme">${0}</dt>
                            <dd class="legend-definiton">${0}</dd>
                        </dl>
                        <dl class="legend-list">
                            <dt class="legend-terme">${0}</dt>
                            <dd class="legend-definiton">${0}</dd>
                        </dl>
                    `), this._getTranslation('penalty-3_short'), this._getTranslation('penalty-3'), this._getTranslation('overtime-3_short'), this._getTranslation('overtime-3')) : '', this._getTranslation('forfait-3_short'), this._getTranslation('forfait-3'));
        case 4:
        case 5:
          return html(_t7 || (_t7 = _`
                <div class="legend">
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                    <dl class="legend-list">
                        <dt class="legend-terme">${0}</dt>
                        <dd class="legend-definiton">${0}</dd>
                    </dl>
                </div>
                `), this._getTranslation('aborted-3_short'), this._getTranslation('aborted-3'), this._getTranslation('postponed-3_short'), this._getTranslation('postponed-3'), this._getTranslation('forfait-3_short'), this._getTranslation('forfait-3'));
      }
    }
  }, {
    key: "shouldShowApartButton",
    value: function shouldShowApartButton(match) {
      var ret = false;
      this.aparttvMatches.some(function (apart) {
        if (match.home_team.id == apart.home_team && match.visitor_team.id == apart.guest_team && match.date === apart.date && apart.time == match.hour) {
          var date = dayjs(`${apart.date} ${apart.time}`).add(2, 'hour');
          var now = dayjs();
          ret = now.isBefore(date) || match.is_live;
        }
      });
      return ret;
    }
  }, {
    key: "_renderDefault",
    value: function _renderDefault() {
      var _this5 = this;
      var results = this.data.results;
      var rounds = this.data.rounds;
      var competitions = this.competitions;
      var competition = this.data.competition;
      var filteredResults = this.filteredResults;
      var tableRows = [];
      var table;
      for (var key in filteredResults) {
        tableRows.push(html(_t8 || (_t8 = _`
                <tr>
                    <th colspan="6" class="results-table__date">${0}</th>
                </tr>
            `), key));
        if (filteredResults.hasOwnProperty(key)) {
          tableRows.push(filteredResults[key].map(function (match) {
            var icon;
            var shouldShowApartButton = _this5.shouldShowApartButton(match);
            if (match.is_paused) {
              icon = html(_t9 || (_t9 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), PauseButtonImage);
            } else {
              if (match.was_played && match.live_arena_id && match.has_details && !match.live_arena_hidden) icon = html(_t10 || (_t10 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), ReplayButtonImage);
              if (match.was_played && match.has_details && (match.live_arena_hidden || match.live_arena_id === null)) icon = html(_t11 || (_t11 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), TickerButtonImage);
              if (match.is_live && match.live_arena_id) icon = html(_t12 || (_t12 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), LiveButtonImage);
              if (match.is_live && !match.live_arena_id) icon = html(_t13 || (_t13 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), LivetickerButtonImage);
              if (!match.was_played && !match.has_details && !match.is_live && match.live_arena_id && !match.live_arena_hidden) icon = html(_t14 || (_t14 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), LiveArenaButtonImage);
              if (shouldShowApartButton) icon = html(_t15 || (_t15 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), ApartLogo);
            }
            var home_logo, visitor_logo;
            var iconSummary;
            if (match.live_arena_summary_url) iconSummary = html(_t16 || (_t16 = _`<img class="results-table__button-highlights" src="${0}" alt="button more"/>`), HighlightButtonImage);
            if (_this5.livearena_sports.includes(_this5.sport)) {
              home_logo = html(_t17 || (_t17 = _`<td class="results-table__team1-img" @click=${0}><img class="results-table__img" src="${0}" /></td>`), function (e) {
                return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
              }, PlaceholderLogo);
              visitor_logo = html(_t18 || (_t18 = _`<td class="results-table__team1-img" @click=${0}><img class="results-table__img" src="${0}" /></td>`), function (e) {
                return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
              }, PlaceholderLogo);
            }
            if (match.home_team.logo_url) home_logo = html(_t19 || (_t19 = _`<td class="results-table__team1-img" @click=${0}><img class="results-table__img" src="${0}?v=${0}" /></td>`), function (e) {
              return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
            }, match.home_team.logo_url, _this5.version);else home_logo = html(_t20 || (_t20 = _`<td class="results-table__team1-img" @click=${0}><img class="results-table__img" src="${0}" /></td>`), function (e) {
              return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
            }, PlaceholderLogo);
            if (match.visitor_team.logo_url) visitor_logo = html(_t21 || (_t21 = _`<td class="results-table__team2-img" @click=${0}><img class="results-table__img" src="${0}?v=${0}" /></td>`), function (e) {
              return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
            }, match.visitor_team.logo_url, _this5.version);else visitor_logo = html(_t22 || (_t22 = _`<td class="results-table__team2-img" @click=${0}><img class="results-table__img" src="${0}" /></td>`), function (e) {
              return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
            }, PlaceholderLogo);
            var sets = [];
            if (match.sets) {
              match.sets.map(function (set) {
                sets.push(html(_t23 || (_t23 = _`
                                <span>${0}:${0}</span>
                            `), set[0], set[1]));
              });
            }
            var showCupHome = false;
            var showCupVisitor = false;
            if (competition.cup && match.home_team.main_competition) showCupHome = true;
            if (competition.cup && match.visitor_team.main_competition) showCupVisitor = true;
            return html(_t24 || (_t24 = _`
                        <tr class="results-table__match${0}${0}${0}${0}">

                            ${0}
                            <td class="results-table__team1" @click=${0}>
                                ${0}
                                ${0}
                            </td>
                            ${0}
                            <td class="results-table__score" @click=${0}>
                                <span class="results-match__scoretext">${0} : ${0}</span>
                                ${0}
                                ${0}
                            </td>
                            ${0}
                            <td class="results-table__team2" @click=${0}>
                                ${0}
                                ${0}
                            </td>
                            ${0}
                            ${0}
                        </tr>
                    `), match.has_details || match.live_arena_id && !match.live_arena_hidden ? ' results-table__match--is-clickable' : '', match.is_paused ? ' results-table__match--ispause' : '', match.is_live ? ' results-table__match--islive' : '', !_this5.showLogos ? ' results-table__match--nologos' : '', _this5.type !== 'small' && _this5.type ? home_logo : '', function (e) {
              return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
            }, _this5.type !== 'small' && _this5.type ? html(_t25 || (_t25 = _`<span class="results-table__teamname">${0}</span><span class="results-table__shortteamname">${0}</span>`), match.home_team.name, match.home_team.short_name) : match.home_team.short_name ? match.home_team.short_name : match.home_team.name, showCupHome ? html(_t26 || (_t26 = _`
                                    <span class="results-table__maincomp results-table__maincomp--name">${0}</span>
                                    <span class="results-table__maincomp results-table__maincomp--short">${0}</span>
                                `), match.home_team.main_competition.name, match.home_team.main_competition.short_name) : '', _this5.type === 'small' ? home_logo : '', function (e) {
              return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
            }, match.home_score, match.visitor_score, match.info !== 'date_unknown' && match.info ? html(_t27 || (_t27 = _`<span class="results-match__info">${0}</span>`), _this5._getTranslation(match.info + '-' + _this5.sport + '_short')) : '', sets.length > 0 ? html(_t28 || (_t28 = _`<span class="results-match__sets">${0}</span>`), sets) : '', _this5.type === 'small' ? visitor_logo : '', function (e) {
              return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
            }, _this5.type !== 'small' && _this5.type ? html(_t29 || (_t29 = _`<span class="results-table__teamname">${0}</span><span class="results-table__shortteamname">${0}</span>`), match.visitor_team.name, match.visitor_team.short_name) : match.visitor_team.short_name ? match.visitor_team.short_name : match.visitor_team.name, showCupVisitor ? html(_t30 || (_t30 = _`
                                    <span class="results-table__maincomp results-table__maincomp--name">${0}</span>
                                    <span class="results-table__maincomp results-table__maincomp--short">${0}</span>
                                `), match.visitor_team.main_competition.name, match.visitor_team.main_competition.short_name) : '', _this5.type !== 'small' && _this5.type ? visitor_logo : '', icon ? html(_t31 || (_t31 = _`
                                <td class="results-table__button-more-container">
                                    <span @click=${0}>${0}</span>
                                    <span @click=${0}>${0}</span>
                                </td>
                            `), function (e) {
              return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden);
            }, icon, function (e) {
              return _this5._showLiveticker(e, match, match.has_details, match.live_arena_id, match.live_arena_hidden, true);
            }, iconSummary) : html(_t32 || (_t32 = _`<td class="results-table__button-more-container"></td>`)));
          }));
        }
      }
      table = html(_t33 || (_t33 = _`<table class="results-table">${0}</table>`), tableRows);
      return html(_t34 || (_t34 = _`
            <div class="results-table__container results-table__container--${0}">
                <div class="results-table__title-team">

                    <h1 class="results-table__title">${0}</h1>

                    ${0}

                    <div class="results-table__teams-container">
                        <select class="results-table__teams arrow-filter-team" style="background: url('${0}') no-repeat; background-position: right" @change=${0}>
                            ${0}
                        </select>
                    </div>
                </div>

                ${0}

                ${0}

                ${0}

            </div>
        `), this.type, this.competitionName, this.type === 'small' || this.type === 'overview' ? html(_t35 || (_t35 = _`
                    <div class="results-table__comp-container">
                        <select class="results-table__comp arrow-filter-comp" style="background: url('${0}') no-repeat; background-position: right" @change=${0}>
                            ${0}
                        </select>
                    </div>
                    `), ArrowDownImage, function (e) {
        return _this5._showCompetition(e);
      }, competitions.map(function (comp) {
        return html(_t36 || (_t36 = _`
                                ${0}
                            `), comp.id === _this5.competition ? html(_t37 || (_t37 = _`<option value="${0}" selected>${0}</option>`), comp.id, comp.name) : html(_t38 || (_t38 = _`<option value="${0}">${0}</option>`), comp.id, comp.name));
      })) : ``, ArrowDownImage, function (e) {
        return _this5._showRound(e);
      }, rounds.map(function (round) {
        return html(_t39 || (_t39 = _`
                                ${0}
                            `), round.id === _this5.round ? html(_t40 || (_t40 = _`<option value="${0}" selected>${0}</option>`), round.id, !isNaN(round.name) ? html(_t41 || (_t41 = _`${0}. ${0}`), round.name, _this5._getTranslation('round')) : html(_t42 || (_t42 = _`${0}`), round.name)) : html(_t43 || (_t43 = _`<option value="${0}">${0}</option>`), round.id, !isNaN(round.name) ? html(_t44 || (_t44 = _`${0}. ${0}`), round.name, _this5._getTranslation('round')) : html(_t45 || (_t45 = _`${0}`), round.name)));
      }), table ? table : '', this.type === 'small' || this.type === 'article' || this.type === 'overview' ? html(_t46 || (_t46 = _`<a @click=${0} class="results-table__more">${0} &raquo;<a>`), function (e) {
        return _this5._showResultsAndTable(e);
      }, this._getTranslation('results_link')) : ``, this._renderLegendBySport());
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data === undefined) return html(_t47 || (_t47 = _`Loading...`));
      if (!this.data.results) return html(_t48 || (_t48 = _`${0}`), this._getTranslation('noresult'));
      return html(_t49 || (_t49 = _`
            <style>${0}</style>

            ${0}
        `), css, this.view === 'default' ? this._renderDefault() : this._renderLiveticker());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        aparttvMatches: {
          type: Array
        },
        sport: {
          type: Number
        },
        // 1: Football / 2: Basketball / 3: Handball / 4: Volleyball / 5: Deschtennis
        competition: {
          type: Number
        },
        version: {
          type: String
        },
        round: {
          type: Number
        },
        view: {
          type: String
        },
        language: {
          type: String
        },
        type: {
          type: String
        },
        link: {
          type: String
        },
        filteredResults: {
          type: String
        }
      };
    }
  }]);
  return RTLSportResults;
}(LitElement);
export { RTLSportResults as default };
window.customElements.define('rtl-sport-results', RTLSportResults);